import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { capitalize } from 'lodash';

import Layout from 'components/Layout';
import LoadingPage from 'components/LoadingPage';
import ErrorPage from 'components/ErrorPage';
import SearchButton from 'components/SearchButton';

const Page = styled.div`
  background: #efeff4;
  box-sizing: border-box;
  min-height: 100%;
  width: 100%;
`;

export default class Collection extends PureComponent {
  static propTypes = {
    appDigestProps: PropTypes.shape({
      onRemove: PropTypes.func,
      showSettings: PropTypes.bool,
      showInstalled: PropTypes.bool
    }),
    apps: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    backText: PropTypes.string.isRequired,
    collection: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    }),
    isApp: PropTypes.bool.isRequired,
    ListPage: PropTypes.func.isRequired,
    showSearch: PropTypes.bool.isRequired
  };

  renderSearchButton() {
    const { isApp, collection, showSearch } = this.props;
    if (showSearch) {
      const type = isApp ? 'apps' : 'clocks';
      return (
        <SearchButton type={type} pageType={capitalize(collection.type)} />
      );
    }
    return null;
  }

  render() {
    const {
      loading,
      error,
      appDigestProps,
      apps,
      hasNextPage,
      backText,
      collection,
      ListPage,
      fetchMore
    } = this.props;

    let listPage = (
      <Page className="app-container">
        <ListPage
          apps={apps}
          hasNextPage={hasNextPage}
          appDigestProps={appDigestProps}
          fetchMore={({ startIndex }) =>
            fetchMore(collection.id, collection.type, startIndex)
          }
        />
      </Page>
    );

    if (error) {
      return <ErrorPage>{error.message}</ErrorPage>;
    } else if (((!apps || apps.length === 0) && loading) || !collection) {
      listPage = (
        <Page>
          <LoadingPage headerHeight={56} />
        </Page>
      );
    }

    return (
      <Layout
        scrollKey="collection"
        backText={backText}
        center={collection.name}
        right={this.renderSearchButton()}
        name={capitalize(collection.type)}
        pageElement={listPage}
      />
    );
  }
}
